// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import debounce from "lodash/debounce";
import { useEffect, useState } from "react";

/**
 * @hook custom react hook to measure the height and width of the screen
 * @return returns an object of two values: width and height
 */
export const useWindowSize = (throttleTimeout = 100) => {
    // Initialize state with undefined width/height so server and client renders match
    const [windowSize, setWindowSize] = useState({
        width: (undefined as unknown) as number,
        height: (undefined as unknown) as number,
    });

    useEffect(() => {
        // Handler to call on window resize
        const handleResize = debounce(() => {
            // Set window width/height to state
            setWindowSize({
                width: window.outerWidth,
                height: window.outerHeight,
            });
        }, throttleTimeout);

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
};
